import { IconButton, HStack, Stack, VStack, Text, Select } from '@genial/components';
import { BoxRadius, Color, BoxBorder } from '@genial/design-tokens';
import React from 'react';

import { InputMoney } from '../../../../../../../components/InputMoney';
import {
  TableContentItemCaptions,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../components/TableContent';
import { mapCaptions } from '../../../../../utils';
import {
  ApplicationInfo,
  FeeInfo,
  MaturityInfo,
  NetValueInfo,
  ProfitabilityInfo,
  RiskInfo,
  TaxInfo,
  UnitPriceInfo,
} from '../../../../DynamicAsset/components/Asset/products/FixedIncome/shared';

import { AddedProductResponsiveItemFixedIncomeProps } from '.';

export const AddedProductItemFixedIncomeDesktop: React.FC<
  AddedProductResponsiveItemFixedIncomeProps
> = (props) => {
  const {
    data,
    inputIsFocused,
    inputMoneyDataProps,
    messageAdjustUnitPriceIsVisible,
    onRemoveProduct,
    ableToChangeFees,
    selectedFee,
    selectedFeeId,
    setSelectedFeeId,
    estimatedIncomeCalculated,
    estimatedNetValueCalculated,
  } = props;

  const infosProps = {
    offer: data,
    selectedFee,
    estimatedIncomeCalculated,
    estimatedNetValueCalculated,
  };

  return (
    <VStack w="full" space="stack.xxxs">
      <HStack w="full" justifyContent="space-between">
        <TableContentItemColumn space="inline.quarck">
          <TableContentItemText>{data.productDisplayNormalized}</TableContentItemText>
          <TableContentItemCaptions forceDesktop icons={mapCaptions(data)} />
        </TableContentItemColumn>
        <IconButton
          testId="icon-button"
          onPress={onRemoveProduct}
          borderRadius={BoxRadius.sm}
          icon="Trash"
          p={0}
          iconColor={Color['feedback.error.default']}
          iconSize="xs"
        />
      </HStack>
      <VStack w="full" space="stack.xxxs">
        <HStack w="full" justifyContent="space-between" alignItems="center">
          <ApplicationInfo w="1/5" {...infosProps} />
          <RiskInfo w="1/5" {...infosProps} />
          <TaxInfo w="1/5" {...infosProps} />
          <ProfitabilityInfo w="1/5" {...infosProps} />
          <MaturityInfo w="1/5" {...infosProps} />
        </HStack>
        <HStack w="full" justifyContent="space-between" alignItems="center">
          <Stack w="1/5">
            <VStack space="stack.quarck" justifyContent="space-between">
              <Text variant="semibold">Taxa</Text>
              {ableToChangeFees ? (
                <Stack mr="inline.xxxs" bgColor="backgroundshade" borderRadius={BoxBorder.thick}>
                  <Select
                    testID="fee-select"
                    options={data.distributionFeesNormalized.map((feeOption) => ({
                      label: feeOption.label,
                      value: feeOption.feeId.toString(),
                    }))}
                    placeholder="--"
                    selectedValue={selectedFeeId?.toString() || ''}
                    onValueChange={(value) => setSelectedFeeId(Number(value))}
                  />
                </Stack>
              ) : (
                <TableContentItemText>
                  {selectedFee?.customerFeeAmountFormatted || '--'}
                </TableContentItemText>
              )}
            </VStack>
          </Stack>
          <UnitPriceInfo w="1/5" {...infosProps} />
          <FeeInfo w="1/5" {...infosProps} />
          <Stack w="1/5">
            <VStack space="stack.quarck" justifyContent="space-between">
              <Text variant="semibold">Valor a aplicar</Text>
              <Stack pr="inline.xxxs">
                <InputMoney {...inputMoneyDataProps} />
                {messageAdjustUnitPriceIsVisible && !inputIsFocused && (
                  <TableContentItemText fontSize="xs" color="neutral.light">
                    Ajustado por preço unitário
                  </TableContentItemText>
                )}
              </Stack>
            </VStack>
          </Stack>
          <NetValueInfo w="1/5" {...infosProps} />
        </HStack>
      </VStack>
    </VStack>
  );
};
